import { Phone } from '$services/api/types'

export const getPhone = ({ phone_code, phone_no }: Partial<Phone>) => {
  const hasPhone = !!phone_code && !!phone_no
  return hasPhone ? `${phone_code}${phone_no}` : undefined
}
